var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('loader'):[_c('launched-app'),_c('launchers'),(_vm.shouldShowScreenSaver)?_c('screen-saver',{on:{"change":function($event){return _vm.setActive()}}}):_vm._e()]],2)}
var staticRenderFns = []

export { render, staticRenderFns }